import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { track } from '@fff-web/fff-analytics';

import { getOrders } from 'services/orders';

import { getItemsCount, getSaleTypes, getShipped, getDropship, getTotalProducts } from 'pages/MyAccount/utils/orders';
import PageContainer from 'pages/MyAccount/shared-components/PageContainer/PageContainer';
import LoadingLogo from 'pages/MyAccount/shared-components/LoadingLogo/LoadingLogo';
import OrdersList from './OrdersList';
import NoOrders from './NoOrders';
import OrderDetails from './OrderDetails';

import styles from './styles.module.scss';

const filterOldOrders = (orders) => orders && orders.filter((order) => {
  const year = moment(order.billingDate).year();
  return year >= 2022;
});
const getTrackingData = (order) => {
  const { billingDate, shipments, orderTotalInCents } = order;
  const saleType = getSaleTypes(shipments);
  const items = getItemsCount(shipments);
  const orderTotal = orderTotalInCents / 100;
  return {
    order_type: saleType,
    total_products: getTotalProducts(shipments),
    order_date: billingDate,
    order_total: orderTotal,
    total_units: items,
  };
};

const Orders = ({ isDesktop }) => {
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [orderDetails, setOrderDetails] = useState(null);
  const { orders: ordersFF } = useFlags();
  const history = useHistory();

  const onClickOrderDetails = (order) => setOrderDetails(order);
  const onClickBack = () => setOrderDetails(null);
  const onClickAllInvoices = () => history.push('/my-account/invoice-history');
  const handleTrackOrderViewed = (order, position) => {
    const trackingData = getTrackingData(order, position)
    const { shipments } = order;
    const totalShipments = getShipped(shipments).length;
    const totalDropships = getDropship(shipments).length;
    track({
      trackName: 'Order Viewed',
      properties: {
        ...trackingData,
        total_shipments: totalShipments,
        event_position_order: position,
        tracking_available: totalShipments > 0,
        dropship: totalDropships > 0,
      },
    })
  };
  const handleTrackShipment = (order, trackingNumber) => {
    const trackingData = getTrackingData(order);
    track({
      trackName: 'Shipment Tracked',
      properties: {
        ...trackingData,
        tracking_number: trackingNumber,
      },
    })
  };
  const renderScreen = () => {
    if (loadingOrders) return <LoadingLogo />;
    if (!orders.length) return <NoOrders />
    if (orderDetails) return (
      <OrderDetails
        order={orderDetails}
        onClickBack={onClickBack}
        trackShipment={handleTrackShipment}
      />
    )
    return (
      <OrdersList
        orders={orders}
        isDesktop={isDesktop}
        onClickAllInvoices={onClickAllInvoices}
        onClickOrderDetails={onClickOrderDetails}
        trackOrderViewed={handleTrackOrderViewed}
        trackShipment={handleTrackShipment}
      />
    )
  };

  useEffect(() => {
    const fetchOrders = async () => {
      const response = await getOrders();
      const filteredOrders = ordersFF ? response : filterOldOrders(response);
      setOrders(filteredOrders);
      setLoadingOrders(false);
    };
    fetchOrders();
  }, [ordersFF])

  return (
    <PageContainer>
      <section className={styles.orders}>
        {renderScreen()}
      </section>
    </PageContainer>
  );
};

Orders.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
};

export default Orders;
